// 现金红包接口
import request from '@/utils/http.js';

// 观看端-获取当前直播有效红包列表
const getLastInfo = params => {
  return request('/v3/vss/red-packet/record/get-last-info', {
    method: 'GET',
    params
  });
}

// 抢红包
const unwrap = params => {
  return request('/v3/vss/red-packet/record/unwrap', {
    method: 'POST',
    data: params
  });
}

// 观看端-领取现金红包
const receive = params => {
  return request('/v3/vss/red-packet/record/receive', {
    method: 'POST',
    data: params
  });
}
//获取红包手气排行榜
const getCashRedpacketRank = params => {
  return request('/v3/vss/red-packet/record/top-list', {
    method: 'GET',
    params
  });
}
//发起端红包开关
// const setRedPacketSwitch = params => {
//   return request('/v3/vss/red-packet/set-switch', {
//     method: 'POST',
//     data: params
//   });
// }
//发起端获取现金红包开关配置
const getRedPacketSwitch = params => {
  return request('/v3/webinars/red-packet/get-config', {
    method: 'GET',
    params
  });
}
//获取提现列表
const getWithdrawList = params => {
  return request('/v3/vss/red-packet/record/receive-list', {
    method: 'GET',
    params
  });
}
export default {
  getLastInfo,
  unwrap,
  receive,
  getCashRedpacketRank,
  // setRedPacketSwitch,
  getRedPacketSwitch,
  getWithdrawList
}